export default __webpack_public_path__ + "static/media/icons8-virtual-reality-100.d30e0b12.svg";